// extracted by mini-css-extract-plugin
export default {"wrap":"Wo-z","logoContainer":"Xo-z","brandImg":"Yo-z","logoImg":"Zo-z","logoButton":"_o-z"};